<script lang="ts">
	import "../app.css";
	import { appState } from "$lib/state/app-state.svelte";
	import { untrack } from "svelte";
	import LeftPanel from "$lib/components/left-panel/LeftPanel.svelte";
	import PageFooter from "$lib/components/page-footer/PageFooter.svelte";
	import LeftMobilePanel from "$lib/components/left-panel/LeftMobilePanel.svelte";
	import Search from "$lib/components/search/Search.svelte";
	import type { LayoutProps } from "./$types";

	let { children, data }: LayoutProps = $props();

	const { slug, groups, document: currentPage, prevLink, nextLink, canonical } = $derived(data);

	appState.menuVisible = false;

	$effect(() => {
		if (appState.darkMode) {
			untrack(() => {
				document.documentElement.classList.remove("light");
				document.documentElement.classList.add("dark");
				document.documentElement.style.colorScheme = "dark";
			});
		} else {
			untrack(() => {
				document.documentElement.classList.remove("dark");
				document.documentElement.classList.add("light");
				document.documentElement.style.colorScheme = "light";
			});
		}
	});
</script>

<svelte:window
	onkeydown={(e) => {
		if (e.key === "k" && (e.ctrlKey || e.metaKey)) {
			appState.searchVisible = !appState.searchVisible;
		}
	}} />

<svelte:head>
	<title>{currentPage?.title ?? "Dokumentace"}</title>
	<link rel="canonical" href={canonical} />
</svelte:head>

{#if currentPage}
	<div class="h-full lg:ml-72 xl:ml-80">
		<LeftPanel groups={groups} slug={slug} />

		<LeftMobilePanel groups={groups} slug={slug} />

		<div class="relative flex h-full flex-col px-4 pt-14 sm:px-6 lg:px-8">
			<div class="flex-auto">
				<article class="flex h-full flex-row pt-16 pb-10">
					<div
						class={[
							"flex-auto",
							"prose",
							"dark:prose-invert",
							"[html_:where(&>*)]:mx-auto",
							"[html_:where(&>*)]:max-w-2xl",
							"lg:[html_:where(&>*)]:mx-[calc(50%-min(50%,var(--container-lg)))]",
							"lg:[html_:where(&>*)]:max-w-3xl",
						]}>
						{@render children()}
					</div>
				</article>
			</div>
			<PageFooter prevLink={prevLink} nextLink={nextLink} />
		</div>
		{#if appState.searchVisible}
			<Search groups={groups} />
		{/if}
	</div>
{/if}
